import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import { Button, Layout, Drawer } from "antd";
import Logo from "./components/Logo";
import { jwtDecode } from "jwt-decode";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import MenuList from "./components/MenuList";
import TutorTable from "./components/TutorTable";
import Team from "./Pages/Team";
import CreateCre from "./Pages/CreateCre";
import Login from "./Pages/login";
import axios from "./axios";
import { useAtom } from "jotai";
import FlashCards from "./components/FlashCards";
import { citysList } from "./states/citys";
import {
  userRole,
  userTutorCityAccess,
  userStudentCityAccess,
  userShadowTutorCityAccess,
  userStudentCityAssignmentAccess,
  userTutorCityAssignmentAccess,
  isTransferPaymentAccess,
} from "./states/userRole";
import { showNavigation } from "./states/showNavigation";
import Student from "./Pages/Student";
import OnlineParents from "./Pages/OnlineParents";
// import PrivateRoute from "./components/PrivateRoute";
import log from "./utility/logging";
import DownloadsTable from "./components/DownloadsTable";
import StudentDetails from "./Pages/StudentDetails";
// import { courseCategoryState, courseStudyLevelState } from "./states/courseMaster";
import App404 from "./Pages/404";
import TutorDetails from "./components/TutorDetails";
import AddNewDeal from "./Pages/AddNewDeal";
import Feedback from "./Pages/Feedback";
import NeedHelp from "./Pages/NeedHelp";
import RecurringPayments from "./Pages/RecurringPayments";
import MenuConfig from "./Pages/MenuConfig";
import PaymentFailed from "./Pages/PaymentFailed";
import TutorEarningsReport from "./Pages/TutorEarningsReport";
import TutorTransferApproval from "./Pages/TutorTransferApproval";
import JobDeals from "./Pages/JobDeals";
import JobApplications from "./Pages/JobApplications";
import JobTemplates from "./Pages/JobTemplates";
import WhatsappTemplates from "./Pages/WhatsappTemplates";
import CityMaster from "./Pages/CityMaster";

const { Sider } = Layout;
const MOBILE_BREAKPOINT = 768;

function SidebarBody({ showMenu, collapsed, onToggle, onItemClick, showToggle }) {
  return (
    <>
      <div className="siderbar-logo">
        <NavLink to="/">
          <Logo />
        </NavLink>
      </div>
      {showMenu && (
        <>
          <div className="siderbar-menu">
            <MenuList onItemClick={onItemClick} />
          </div>
          {showToggle && (
            <div className="sideNavToggle-wrapper">
              <Button
                type="text"
                className="toggle"
                onClick={onToggle}
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              />
            </div>
          )}
        </>
      )}
    </>
  );
}

function App() {
  const [collapsed, setCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT
  );
  const [showMenu, setShowMenu] = useAtom(showNavigation);
  const [studentCityAccess, setStudentCityAccess] = useAtom(userStudentCityAccess);
  const [tutorCityAccess, setTutorCityAccess] = useAtom(userTutorCityAccess);
  const [shadowTutorCityAccess, setShadowTutorCityAccess] = useAtom(userShadowTutorCityAccess);
  const [studentCityAssignmentAccess, setStudentCityAssignmentAccess] = useAtom(userStudentCityAssignmentAccess);
  const [tutorCityAssignmentAccess, setTutorCityAssignmentAccess] = useAtom(userTutorCityAssignmentAccess);
  const [, setIsTransferPaymentAccess] = useAtom(isTransferPaymentAccess);

  const [citys, setCitys] = useAtom(citysList);
  const [role, setRole] = useAtom(userRole);

  useEffect(() => {
    try {
      axios
        .get("/v1/cre/citys")
        .then((response) => {
          const citysList = response.data.data;
          setCitys(citysList);
          if (window.localStorage.getItem("homeshiksha-cre-jwt")) {
            const decoded = jwtDecode(localStorage.getItem("homeshiksha-cre-jwt"));
            setRole(decoded.authorization.x_authorization_role);
            setTutorCityAccess(decoded.authorization.x_authorization_tutor_city?.split(","));
            setStudentCityAccess(decoded.authorization.x_authorization_student_city?.split(","));
            setShadowTutorCityAccess(decoded.authorization.x_authorization_shadow_tutor_city?.split(","));
            setStudentCityAssignmentAccess(decoded?.authorization?.x_authorization_student_city_assignment?.split(","));
            setTutorCityAssignmentAccess(decoded?.authorization?.x_authorization_tutor_city_assignment?.split(","));
            setIsTransferPaymentAccess(
              decoded.authorization?.x_authorization_is_transfer_payment === "1"
            );
            setShowMenu(true);
          }
        })
        .catch((error) => {
          log.debug(error);
        });
    } catch (error) {
      log.debug(error);
    }
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const applyBreakpoint = (matches) => {
      setIsMobile(matches);
      if (matches) {
        setCollapsed(true);
      }
    };

    applyBreakpoint(mediaQuery.matches);
    const onChange = (event) => applyBreakpoint(event.matches);
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }, []);

  const closeSidebar = () => setCollapsed(true);
  const toggleSidebar = () => setCollapsed((isCollapsed) => !isCollapsed);

  return (
    <main>
      <Router>
        <Layout className="app-shell">
          {!isMobile && (
            <Sider
              className="siderbar"
              collapsed={collapsed}
              collapsible
              trigger={null}
              width={220}
              collapsedWidth={80}
            >
              <SidebarBody
                showMenu={showMenu}
                collapsed={collapsed}
                onToggle={toggleSidebar}
                showToggle
              />
            </Sider>
          )}
          {isMobile && (
            <Drawer
              className="mobile-sider-drawer"
              placement="left"
              open={showMenu && !collapsed}
              onClose={closeSidebar}
              width={260}
              closable={false}
              styles={{
                body: {
                  padding: 0,
                  background: "#001529",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                },
              }}
            >
              <SidebarBody
                showMenu={showMenu}
                collapsed={false}
                onToggle={closeSidebar}
                onItemClick={closeSidebar}
                showToggle
              />
            </Drawer>
          )}
          <Layout
            className="main-layout"
            onClick={() => {
              if (!collapsed && !isMobile) {
                closeSidebar();
              }
            }}
          >
            {isMobile && showMenu && (
              <div className="mobile-topbar">
                <Button
                  type="text"
                  className="mobile-nav-trigger"
                  aria-label="Open navigation"
                  onClick={(event) => {
                    event.stopPropagation();
                    setCollapsed(false);
                  }}
                  icon={<MenuUnfoldOutlined />}
                />
                <span className="mobile-topbar-title">HomeShiksha CRM</span>
              </div>
            )}
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/students" element={<Student />} />
              <Route path="/online-parents" element={<OnlineParents />} />
              <Route path="/recurring-payments" element={<RecurringPayments />} />
              <Route path="/add-new-deal" element={<AddNewDeal />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/need-help" element={<NeedHelp />} />
              <Route path="/tutors" element={<TutorTable />} />
              <Route path="/create-cre" element={<CreateCre />} />
              <Route path="/cre-team" element={<Team />} />
              <Route path="/donwload-data" element={<DownloadsTable />} />
              <Route path="/home" element={<FlashCards />} />
              <Route path="/student/:dealings_id" element={<StudentDetails />} />
              <Route path="/tutor/:id" element={<TutorDetails />} />
              <Route path="/tutor/:id/earnings-report" element={<TutorEarningsReport />} />
              <Route path="*" element={<>404</>} />
              <Route path="404" element={<App404 />} />
              <Route path="/menu-config" element={<MenuConfig />} />
              <Route path="/city-master" element={<CityMaster />} />
              <Route path="/payment-failed" element={<PaymentFailed />} />
              <Route path="/job-deals" element={<JobDeals />} />
              <Route path="/job-applications" element={<JobApplications />} />
              <Route path="/job-templates" element={<JobTemplates />} />
              <Route path="/whatsapp-templates" element={<WhatsappTemplates />} />
              <Route path="/tutor-transfer-approval" element={<TutorTransferApproval />} />
            </Routes>
          </Layout>
        </Layout>
      </Router>
    </main>
  );
}

export default App;
